import React from 'react';
import styled from 'styled-components';
import { COLOR_ACCENT, COLOR_ACCENT_DARK, COLOR_BACKGROUND_BRIGHT, DEVICES } from '../../const';
import VideoBannerMask1 from '../../assets/video-banner-mask1.png';
import VideoBannerMask2 from '../../assets/video-banner-mask2.png';

const Background = styled.div`
  background-color: ${COLOR_BACKGROUND_BRIGHT};
  position: relative;
`;

const Inner = styled.div`
  margin: auto;
  position: relative;

  @media ${DEVICES.mobile} {
    display: block;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    height: 700px;
    align-items: center;
    flex-direction: row-reverse;
  }

  @media ${DEVICES.large} {
    display: flex;
    height: 700px;
    max-width: 1200px;
    align-items: center;
    flex-direction: row-reverse;
  }
`;

const Mask1 = styled.div`
  background-image: url(${VideoBannerMask1});
  background-size: 100%;
  background-repeat: no-repeat;
  width: 100%;
  aspect-ratio: 1920 / 245;
  position: absolute;
  left: 0;

  @media ${DEVICES.mobile} {
    bottom: 15px;
  }

  @media ${DEVICES.tablet} {
    bottom: 40px;
  }
`;

const Mask2 = styled.div`
  background-image: url(${VideoBannerMask2});
  background-size: 100%;
  background-repeat: no-repeat;
  width: 100%;
  aspect-ratio: 1920 / 245;
  position: absolute;
  bottom: 0px;
  left: 0;
`;

const Left = styled.div`

  @media ${DEVICES.mobile} {
    text-align: center;
    padding: 0 2rem;
  }

  @media ${DEVICES.tablet} {
    text-align: center;
    padding: 2rem;
  }

  @media ${DEVICES.laptop} {
    width: 40%;
    text-align: left;
  }
`;

const CatchPhrase = styled.div`
  font-weight: 700;
  line-height: 1.5;

  @media ${DEVICES.mobile} {
    font-size: 2rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.5rem;
  }
`;

const Description = styled.div`
  font-weight: 300;
  margin-top: 2rem;

  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const ContactButton = styled.button`
  border-radius: 1rem;
  padding: 1.5em 1.5rem;
  text-align: center;
  background-color: ${COLOR_ACCENT_DARK};
  color: #fff;
  margin-top: 2rem;
  border: 0;
  font-weight: 600;
  font-size: 1rem;
  width: 280px;
  line-height: 1;
  cursor: pointer;

  @media ${DEVICES.mobile} {
    margin-bottom: 72px;
    width: 200px;
  }

  @media ${DEVICES.tablet} {
    width: 280px;
  }

  &:hover {
    background-color: ${COLOR_ACCENT};
  }
`;

const Right = styled.div`
  padding: 2rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 60%;
  }
`;

const VideoPlayerWrapper = styled.div`
  border: none;
  box-shadow: 1px 18px 57px -25px rgb(0 0 0 / 67%);
  border-radius: 16px;
  overflow: hidden;

  @media ${DEVICES.mobile} {
    width: 280px;
    height: 280px;
  }

  @media ${DEVICES.tablet} {
    width: 350px;
    height: 350px;
  }

  @media ${DEVICES.laptop} {
    width: 450px;
    height: 450px;
  }
`;

const VideoPlayer = styled.video`
  width: 100%;
  height: 100%;
  object-fit: fill;
`;

export default function VideoBanner() {

  const openForm = () => {
    window.open('https://forms.gle/Rk71QVRAfZ2TpRc78');
  };

  return (
    <Background>
      <Mask1 />
      <Mask2 />
      <Inner>
        <Right>
          <VideoPlayerWrapper>
            <VideoPlayer
              src={'https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/main_video.mp4'}
              loop muted autoPlay playsInline
            />
          </VideoPlayerWrapper>
        </Right>
        <Left>
          <CatchPhrase>
            SOUND BODY
          </CatchPhrase>
          <CatchPhrase>
            SOUND MIND
          </CatchPhrase>
          <Description>
            디지털 빌런이 잠식하고 있는 세대에 <br />
            살아가는 유소년에게 체계적인 신체활동은 <br />
            이제 필수 사항입니다
          </Description>
          <ContactButton onClick={openForm}>
            체험 수업 신청하기
          </ContactButton>
        </Left>
      </Inner>
    </Background>
  )
}
